




















import { Component, Vue, Watch } from 'vue-property-decorator';
import Datatable from '@/components/Datatable.vue';
import ProgramItem from '@/components/prescriber/ProgramItem.vue';
import ListModule from '../../store/ListModule';
import MetaDatatable from '../../models/MetaDatatable';

@Component({
    components: {
        Datatable,
    },
})
export default class ProgramsList extends Vue {
    columns: any[] = [
        {
            title: 'Nom',
            dataIndex: 'name',
            sorter: true,
        },
        {
            title: '',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
        },
    ];
    meta: any = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 5,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };

    get programs() {
        return ListModule.programs;
    }
    fetch() {
        return { meta: this.meta, data: this.programs };
    }

    get lotsSelected() {
        return ListModule.lotsSelected;
    }

    lotSelect(lot: any) {
        this.$emit('lotSelect', lot);
    }
}
